import scrollbarTrack from 'assets/images/ui/scrollbar_track.png';
import { COLORS } from 'theme/MainTheme';

const scrollContainer = {
  height: '100%',
  overflow: 'auto',

  '&::-webkit-scrollbar': {
    width: 7,
  },
  '&::-webkit-scrollbar-track': {
    backgroundImage: `url(${scrollbarTrack as string})`,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: COLORS.VIOLET,
    borderRadius: 11,
    width: 6,
  },
};

export default scrollContainer;